"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var word_mapping_1 = require("./word-mapping");

var ConverterUtil = function () {
  function ConverterUtil(value, tenthMapping, subHundredMapping, max, decimalNotation, negativeNotation) {
    if (tenthMapping === void 0) {
      tenthMapping = word_mapping_1.WORD_MAPPING.international.en.tenths;
    }

    if (subHundredMapping === void 0) {
      subHundredMapping = word_mapping_1.WORD_MAPPING.international.en.subHundreds;
    }

    if (max === void 0) {
      max = 1000 * word_mapping_1.WordValues.trillion - 1;
    }

    if (decimalNotation === void 0) {
      decimalNotation = 'point';
    }

    if (negativeNotation === void 0) {
      negativeNotation = 'minus';
    }

    this.words = [];

    if (typeof value === 'string') {
      if (isNaN(+value)) {
        console.error("value not number: " + value + " is not a number. Please ensure the value is a number");
      }

      value = +value;
    }

    if (value > max) {
      console.error("value not supported: " + value + " exceeds the max value");
    }

    this.value = value;

    if ((this.value || this.value === 0) && value <= max) {
      value = +value;
      this.tenthMapping = tenthMapping;
      this.subHundredMapping = subHundredMapping;
      this.maxValue = max;
      this.decimalNotation = decimalNotation;
      this.negativeNotation = negativeNotation;
      var isNegative = value < 0;

      if (isNegative) {
        value = Math.abs(value);
        this.words = [this.negativeNotation];
      }

      var decimalWords = [];
      var valueAfterPoint = /\.\d+/.exec(value.toString());

      if (valueAfterPoint) {
        decimalWords = this.convertDecimalToWords(valueAfterPoint[0]);
      }

      value = Math.floor(value);
      this.words = this.words.concat(this.convertToWords(value), decimalWords);
    }
  }

  ConverterUtil.prototype.convertToWords = function (value) {
    if (value === null || value === undefined) {
      return [];
    }

    if (value < 100) {
      return this.convertSubHundredToWords(value);
    }

    var length = value.toString().length;
    var pow10 = Math.pow(10, length - 1);
    var category = '';

    while (!category) {
      category = this.tenthMapping[pow10] || '';

      if (!category) {
        pow10 /= 10;
      }
    }

    var numberof0s = /0+/.exec(pow10.toString())[0].length;
    var prefix = value.toString().slice(0, length - numberof0s);
    var suffix = +value.toString().slice(-numberof0s);
    return this.convertToWords(+prefix).concat([category], this.convertToWords(suffix ? suffix : null));
  };

  ConverterUtil.prototype.convertSubHundredToWords = function (value) {
    if (this.subHundredMapping[value]) {
      return [this.subHundredMapping[value]];
    }

    var splitValue = (value / 10).toString().split('.');
    return [this.tenthMapping[+splitValue[0] * 10], this.subHundredMapping[splitValue[1]]];
  };

  ConverterUtil.prototype.convertDecimalToWords = function (decimal) {
    var _this = this;

    var decimalValues = decimal.split('');
    return decimalValues.map(function (dec) {
      if (dec === '.') {
        return _this.decimalNotation;
      }

      return _this.subHundredMapping[dec];
    });
  };

  ConverterUtil.prototype.getWords = function () {
    return this.words.filter(function (word) {
      return !!word;
    }).join(' ');
  };

  return ConverterUtil;
}();

exports.ConverterUtil = ConverterUtil;